import React from "react";
import "./MainScreenRightSidebar.css";

const  MainScreenRightSidebar = () => {

  return (
    <div className="main-screen-right-sidebar">
      <div className="rectangle-6456 border-1px-athens-gray-3"></div>
    </div>
  );
}

export default MainScreenRightSidebar;
